@if (displayAsCheckboxList) {
  <fieldset class="multi-select__checkbox-list" [class.ng-invalid]="control.invalid && control.touched" [class.ng-dirty]="control.touched">
    <legend class="multi-select__checkbox-list-label">{{ label }}</legend>
    @for (option of options; track option.id) {
      <label class="multi-select__checkbox-option" [for]="id + '_' + option.id">
        <p-checkbox
          [inputId]="id + '_' + option.id"
          [binary]="true"
          [ngModel]="isChecked(option.id)"
          [disabled]="control.disabled"
          (onChange)="onCheckboxChange(option.id, !!$event.checked)"
        />
        <span>{{ option.displayValue }}</span>
      </label>
    }
  </fieldset>
} @else {
  <p-floatlabel [variant]="variant" class="input-field">
    <p-multiselect
      [inputId]="id"
      [options]="options"
      [formControl]="control"
      appendTo="body"
      optionLabel="displayValue"
      optionValue="id"
      [showClear]="true"
      [filter]="true"
      display="chip"
      [fluid]="true"
      [virtualScroll]="true"
      [virtualScrollItemSize]="40"
      [class.ng-invalid]="control.invalid && control.touched"
      [class.ng-dirty]="control.touched"
    />
    @if (hasLabel()) {
      <label [for]="id">{{ label }}</label>
    }
  </p-floatlabel>
}
@if (control.invalid && control.touched) {
  <small class="multi-select__error">{{ errorMessage ?? 'This field is required' }}</small>
}
